import "../styles/globals.css"
import "tailwindcss/tailwind.css"
import getConfig from "next/config"
import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import * as ga from "../lib/ga"
import ToastWrapper from "../components/ToastContainer"
import SplashPage from "../components/SplashPage"

const { publicRuntimeConfig} = getConfig()
const { featureFlags }  = publicRuntimeConfig;

function MyApp({ Component, pageProps }) {
  const [showSplashPage, setShowSplashPage] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = (url) => {
      ga.pageview(url)
    }
    //When the component is mounted, subscribe to router changes
    //and log those page views
    router.events.on("routeChangeComplete", handleRouteChange)

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange)
    }
  }, [router.events])

  useEffect(() => {
    // Check the feature flag in next.config.js to determine if the splash page should be shown
    if (featureFlags?.showSplashPage) {
      setShowSplashPage(true)
    }
  }, [])

  return (
    <main>
      <ToastWrapper />
      {showSplashPage ? <SplashPage /> : <Component {...pageProps} />}
      {/* <Component {...pageProps} /> */}
    </main>
  )
}

export default MyApp
